import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dc-restore-password',
  templateUrl: './restore-password.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonModule, InputTextModule, MessageModule],
})
export class RestorePasswordComponent implements OnInit {
  restoreForm: FormGroup;

  constructor(private fb: FormBuilder, public ref: DynamicDialogRef) {
    this.restoreForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {}

  submit() {
    if (this.restoreForm.valid) {
      this.ref.close(this.restoreForm.value.email);
    }
  }

  close() {
    this.ref.close();
  }
}
